var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFarcaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 429 429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.22,150.64l12.39-41.95h-59.11v-41.95H108.67v41.95h-55.29l12.39,41.95h10.49v169.69c-5.26,0-9.53,4.27-9.53,9.53v11.44h-1.91c-5.26,0-9.53,4.27-9.53,9.53v11.44h106.77v-11.44c0-5.26-4.26-9.53-9.53-9.53h-1.91v-11.44c0-5.26-4.26-9.53-9.53-9.53h-1.91v-93.43h.3c3.37-37.41,34.82-66.73,73.11-66.73s69.74,29.32,73.11,66.73h.3v93.62c-4.35.88-7.63,4.73-7.63,9.34v11.44h-1.91c-5.26,0-9.53,4.27-9.53,9.53v11.44h106.77v-11.44c0-5.26-4.26-9.53-9.53-9.53h-1.91v-11.44c0-5.26-4.26-9.53-9.53-9.53v-169.69h10.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarcaster);
export default __webpack_public_path__ + "static/media/Farcaster.f49c292e66fa243bf58469cf5a2a39a3.svg";
export { ForwardRef as ReactComponent };